const TRAILING_GUID_SUFFIX_PATTERN = /_[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/

export const getUploadedAudienceFileName = (url?: string): string | undefined => {
  const lastSegment = url?.split('/').pop()

  if (!lastSegment) {
    return undefined
  }

  const lastDotIndex = lastSegment.lastIndexOf('.')
  const hasExtension = lastDotIndex > 0
  const namePart = hasExtension ? lastSegment.slice(0, lastDotIndex) : lastSegment
  const extension = hasExtension ? lastSegment.slice(lastDotIndex) : ''

  return `${namePart.replace(TRAILING_GUID_SUFFIX_PATTERN, '')}${extension}`
}
